import { Box } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import React, { useMemo, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import StarBorder from "@mui/icons-material/StarBorder";
import NirantaraIcon from "../assets/images/vajra.svg";
import {
  miniSidebarElements,
  sidebarElements1,
  sidebarElementsFacility,
} from "../utils/constant";
import scopeoverview from "../assets/images/Sidebar/scopeoverview.svg";
import mobilecombustion from "../assets/images/Sidebar/mobilecombustion.svg";
import stationarycombustion from "../assets/images/Sidebar/stationarycombustion.svg";
import fugitiveemissions from "../assets/images/Sidebar/fugitiveemission.svg";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Tooltip } from "@mui/material";
import SidebarItemsRenderer from "../utils/layoutFunctions";
import { useUser } from "../context/AuthContext";
import {
  filterMiniSidebarElements,
  getRoleBasedSidebar,
} from "../utils/sidebarFunctions";

const mastersSidebarElements = [
  {
    text: "Overview",
    icon: scopeoverview,
    path: "/scope1/dashboard",
  },
  {
    text: "Stationary Combustion",
    icon: stationarycombustion,
    path: "",
    moduleName: "Environment | Scope 1 | Stationary Combustion",
    children: [
      {
        text: "Natural Gas",
        icon: StarBorder,
        path: "/scope1/natural-gas",
      },
      {
        text: "Coal",
        icon: StarBorder,
        path: "/scope1/stationary-combustion/coal",
      },
      {
        text: "Petroleum / Gasoline",
        icon: StarBorder,
        path: "/scope1/stationary-combustion/petroleumGasoline",
      },
      {
        text: "Diesel",
        icon: StarBorder,
        path: "/scope1/stationary-combustion/diesel",
      },
      {
        text: "Fuel Oil",
        icon: StarBorder,
        path: "/scope1/stationary-combustion/fuel-oil",
      },
      {
        text: "LPG",
        icon: StarBorder,
        path: "/scope1/stationary-combustion/lpg",
      },
      {
        text: "Propane",
        icon: StarBorder,
        path: "/scope1/stationary-combustion/propane",
      },
    ],
  },
  {
    text: "Mobile Combustion",
    icon: mobilecombustion,
    path: "",
    moduleName: "Environment | Scope 1 | Mobile Combustion",
    children: [
      {
        text: "On Road Vehicles",
        icon: StarBorder,
        path: "/scope1/onroad-vehicles",
      },
      {
        text: "Off Road Vehicles",
        icon: StarBorder,
        path: "/scope1/Mobile-combustion/OffRoad",
      },
    ],
  },
  {
    text: "Fugitive Emissions",
    icon: fugitiveemissions,
    path: "/scope1/FugitiveEmmissions/FireExtingulsher",
    moduleName: "Environment | Scope 1 | Fugitive Emissions",
    children: [
      {
        text: "Refrigeration and Air Conditioning System",
        icon: StarBorder,
        path: "/scope1/fugitive-emission/refrigeration",
      },
      {
        text: "Fire Extinguishers",
        icon: StarBorder,
        path: "/scope1/FugitiveEmmissions/FireExtingulsher",
      },
      {
        text: "Industrial Process Release",
        icon: StarBorder,
        path: "/scope1/fugitive-emmissions/industrial-process",
      },
    ],
  },
];

const Scope1Layout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useUser();

  const [isHovered, setIsHovered] = useState(false);

  const filteredSidebarElements = useMemo(() => {
    if (!user?.modules || user?.facilityManger || user?.companyAdmin)
      return mastersSidebarElements;

    return mastersSidebarElements.filter((item) => {
      return !item.moduleName || user.modules.includes(item.moduleName);
    });
  }, [user?.modules]);

  const [open, setOpen] = useState(() => {
    const activeHeader = filteredSidebarElements.find((item) =>
      item.children?.some((child) => child.path === location.pathname)
    );
    return activeHeader
      ? {
        index: filteredSidebarElements.indexOf(activeHeader),
        header: activeHeader.text,
      }
      : {};
  });

  const sidebarElements = getRoleBasedSidebar({
    user,
    sidebarElements1,
    sidebarElementsFacility,
  });

  const filteredSidebar = sidebarElements.map((item) => {
    if (item.path === "/production-revenue") {
      return {
        ...item,
        heading: user?.companyAdmin ? "Production & Revenue" : "Production",
      };
    }
    if (item.heading === "Setup" && item.subData) {
      const newSubData = item.subData.filter(
        (sub) => sub.primary !== "Facility Master" || !user?.facility
      );
      return { ...item, subData: newSubData };
    }
    return item;
  });

  const miniSidebarFiltered = filterMiniSidebarElements({
    user,
    miniSidebarElements,
  });

  const handleClick = (item, index) => {
    setOpen((prevOpen) =>
      prevOpen.index === index ? {} : { index, header: item.text }
    );
  };

  const renderMainSidebarItems = (elements) => {
    return elements.map((item, index) => (
      <div
        key={index}
        style={{
          fontFamily: "Inter",
          display: "flex",
          flexDirection: "column",
          marginTop: "0.25rem",
        }}
      >
        <div
          key={index}
          style={{
            display: "flex",
            justifyContent: "center",
            backgroundColor:
              item.primary === "Scope 1" ? "#488257" : "transparent",
          }}
        >
          <Tooltip
            title={item.title}
            arrow
            placement="bottom-start"
            PopperProps={{
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, 0],
                  },
                },
              ],
            }}
            componentsProps={{
              tooltip: {
                sx: {
                  color: "#fff",
                  fontSize: "12px",
                  borderRadius: "4px",
                  padding: "0.25rem 0.5rem",
                },
                arrow: {
                  color: "#fff",
                },
              },
            }}
          >
            <a
              href={item.path}
              key={item.primary}
              style={{
                textDecoration: "none",
                color: "green",
                padding: "0.4rem",
                borderRadius: "4px",
              }}
            >
              <Box
                component="img"
                src={item.icon}
                alt={"img"}
                sx={{
                  width: "24px",
                  height: "24px",
                }}
              />
            </a>
          </Tooltip>
        </div>
      </div>
    ));
  };

  const renderSecondarySidebarItems = (elements, heading) => {
    return (
      <div style={{ width: "100%", fontFamily: "Inter", marginTop: "1.5rem" }}>
        {heading && (
          <p
            style={{
              color: "#fff",
              fontWeight: "700",
              fontSize: "24px",
              padding: "0 2rem 0.5rem 0.5rem",
              marginLeft: "1rem",
              borderBottom: "2px solid #fff",
              display: "inline-block",
            }}
          >
            {heading}
          </p>
        )}
        {elements.map((item, index) => {
          const isChildSelected =
            item.children &&
            item.children.some((child) => location.pathname === child.path);

          return item.heading ? (
            <p
              key={`heading-${index}`}
              style={{
                color: "rgba(255, 255, 255, 1)",
                paddingLeft: "1rem",
                marginBottom: "0.5rem",
                marginTop: "1rem",
                fontFamily: "Public Sans",
                fontSize: "11px",
                fontWeight: 400,
                lineHeight: "14px",
              }}
            >
              {item.heading}
            </p>
          ) : (
            <div key={`item-${index}`}>
              <Link
                to={item.path}
                onClick={(e) => {
                  if (item.children) {
                    e.preventDefault();
                    handleClick(item, index);
                  } else {
                    // navigate(item.path);
                  }
                }}
                style={{
                  textDecoration: "none",
                  color:
                    location.pathname === item.path || isChildSelected
                      ? "#488257"
                      : "#ffffff",
                  display: "flex",
                  padding: "0.5rem",
                  margin: "4px 8px",
                  backgroundColor:
                    location.pathname === item.path || isChildSelected
                      ? "#ffffff"
                      : "transparent",
                  borderRadius: "4px",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <Box
                  component="img"
                  src={item.icon}
                  alt={"img"}
                  sx={{
                    filter:
                      location.pathname === item.path || isChildSelected
                        ? "invert(32%) sepia(23%) saturate(900%) hue-rotate(90deg) brightness(70%) contrast(100%)"
                        : "invert(0)",
                  }}
                />
                <span
                  style={{
                    marginLeft: "1rem",
                    fontSize: "16px",
                    fontWeight: "400",
                    color: "inherit",
                  }}
                >
                  {item.text}
                </span>
                {item.children && (
                  <span style={{ marginLeft: "auto", fontSize: "16px" }}>
                    {open?.header === item.text ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )}
                  </span>
                )}
              </Link>
              {item.children && open?.header === item.text && (
                <div style={{ paddingLeft: "0.5rem" }}>
                  {item.children.map((child, childIndex) => (
                    <Link
                      key={`child-${childIndex}`}
                      to={child.path}
                      onClick={(e) => {
                        // navigate(child.path);
                      }}
                      style={{
                        textDecoration: "none",
                        color: "#ffffff",
                        display: "flex",
                        padding: "0.5rem 0 0.5rem 0.5rem",
                        margin: "4px 8px",
                        borderRadius: "4px",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      {location.pathname === child.path ? (
                        <CheckCircleOutlineIcon
                          style={{
                            width: "16px",
                          }}
                        />
                      ) : (
                        <RadioButtonUncheckedIcon
                          style={{
                            width: "16px",
                          }}
                        />
                      )}
                      <span
                        style={{
                          marginLeft: "0.5rem",
                          fontSize: "16px",
                          fontWeight: "400",
                          color: "inherit",
                        }}
                      >
                        {child.text}
                      </span>
                    </Link>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <>
      <Box style={{ display: "flex" }}>
        <div
          style={{
            width: "22.5%",
            height: "100vh",
            backgroundColor: "#E6E6E6",
            position: "relative",
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <Box display="flex" justifyContent="center" py={1}>
            <img
              src={NirantaraIcon}
              alt="Nirantara Logo"
              style={{ cursor: "pointer", height: "36px", width: "36px" }}
              onClick={() => navigate("/dashboard")}
            />
          </Box>
          <div style={{ width: "100%", marginTop: "1rem" }}>
            {renderMainSidebarItems(miniSidebarFiltered)}
          </div>

          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "21.25vw",
              height: "100vh",
              backgroundColor: "#fff",
              zIndex: 10,
              overflowY: "auto",
              transform: isHovered ? "translateX(0)" : "translateX(-100%)",
              opacity: isHovered ? 1 : 0,
              transition: "opacity 0.4s ease, transform 0.4s ease",
              pointerEvents: isHovered ? "auto" : "none",
              willChange: "transform, opacity",
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {<SidebarItemsRenderer elements={filteredSidebar} />}
          </div>
        </div>
        <div
          style={{
            backgroundColor: "#488257",
            width: "77.5%",
          }}
        >
          {renderSecondarySidebarItems(filteredSidebarElements, "Scope 1")}
        </div>
      </Box>
    </>
  );
};

export default Scope1Layout;
